module.exports = __webpack_public_path__ + "img/thumbnail_Llama_j_albino.2ce74524.png";